"use client";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import fetchGraphQL, { createnNewsletterSubscription } from "@/helper/fetch";
import { useRouter } from "next/navigation";
import toast from "react-hot-toast";
import { VscGithub } from "react-icons/vsc";
import { BsGithub } from "react-icons/bs";

async function GetGlobals() {
  const QUERY = `query {
        sectionCollection {
            items {
                phone1,
                phone2,
                email
            }
        }
    }`;

  const result = await fetchGraphQL(QUERY);

  return {
    email: result.data?.sectionCollection.items[0].email,
    phone1: result.data?.sectionCollection.items[0].phone1,
    phone2: result.data?.sectionCollection.items[0].phone2,
  };
}

const Footer = () => {
  const router = useRouter();

  const [email, setEmail] = useState("");

  const subscribeToNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    const { success } = await createnNewsletterSubscription(email);
    if (success) {
      toast.success("Newsletter subscribed successfully!");
    } else {
      toast.success("Newsletter already subscribed!");
    }
    setEmail("");
  };
  const [globals, setGlobals] = useState<{
    phone1: string;
    phone2: string;
    email: string;
  }>({ phone1: "", phone2: "", email: "" });
  useEffect(() => {
    const getGlobals = async () => {
      const globals = await GetGlobals();
      setGlobals(globals);
    };
    getGlobals();
  }, []);

  return (
    <footer className="footer   mt-[190px] md:mt-[180px] lg:mt-[150px]">
      <div className="shell relative">
        <div className="bg-black shadow-2xl  absolute w-[95%] left-[50%] -translate-x-1/2 top-[-190px  ] md:top-[-130px] lg:top-[-120px] text-white p-10 rounded-2xl flex flex-wrap justify-center md:justify-between items-center">
          <div className=" text-lg lg:text-4xl font-bold">
            <p>БЪДИ В КРАЧКА С</p>
            <p>НАЙ-НОВИТЕ НИ</p>
            <p>ПРЕДЛОЖЕНИЯ</p>
          </div>

          <form onSubmit={subscribeToNewsletter}>
            <div className="flex flex-col gap-4 items-center w-[280px] ">
              <div className="relative mx-6 mt-4 md:my-0  w-full">
                <input
                  type="email"
                  placeholder="Въведи своя имейл адрес"
                  className="pl-10 pr-4 py-2.5 rounded-full text-black outline-none w-full"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <span className="absolute left-3 top-3 text-gray-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M2.94 3.23a3 3 0 011.875-.813h10.37a3 3 0 011.874.813l.01.01.007.007a.65.65 0 01.006.006l.007.006a3 3 0 01.813 1.876v9.78a3 3 0 01-.813 1.875 3 3 0 01-1.876.813H4.815a3 3 0 01-1.875-.813l-.007-.006a.65.65 0 01-.006-.007l-.006-.007A3 3 0 012 15.27V5.493a3 3 0 01.813-1.876l.007-.007a.65.65 0 01.007-.007l.007-.007a3 3 0 011.875-.813zm1.875.812A1 1 0 003.819 5.06v9.78a1 1 0 00.94 1.065h10.37a1 1 0 00.94-1.065V5.06a1 1 0 00-.94-1.065H4.815zM5.47 7.47L9.76 10.31a.5.5 0 00.48 0l4.29-2.84a.5.5 0 10-.48-.86L10 9.25 5.95 6.61a.5.5 0 00-.48.86z" />
                  </svg>
                </span>
              </div>{" "}
              <button
                className="bg-white text-black py-2.5 px-8 rounded-full w-full"
                type="submit"
              >
                Абонирай се нашия бюлетин
              </button>{" "}
            </div>
          </form>
        </div>
        <div className="footer__inner w-full">
          <div className="  lg:mt-14 mt-[300px]">
            {/* <p>ул. „Хаджи Стамат Сидеров“ №32 гр. Варна</p> */}
            <a href="/" className="logo logo--large">
              <Image
                src="/temp/logo.png"
                alt="logo"
                className="logo--large"
                width={150}
                height={100}
                objectFit="contain"
              />
            </a>
            <ul className="footer__contacts">
              <li>
                <a href={`mail:${globals.email}}`}>
                  <Image
                    src="/email.svg"
                    alt="email"
                    width={100}
                    height={100}
                    objectFit="contain"
                  />

                  <p>{globals.email}</p>
                </a>
              </li>

              <li>
                <a href={`tel:${globals.phone1}}`}>
                  <Image
                    src="/phone.svg"
                    alt="phone"
                    width={100}
                    height={100}
                  />

                  <p>{globals.phone1}</p>
                </a>
              </li>

              <li>
                <a href={`tel:${globals.phone2}}`}>
                  <Image
                    src="/phone.svg"
                    alt="phone"
                    width={100}
                    height={100}
                  />

                  <p>{globals.phone2}</p>
                </a>
              </li>
            </ul>

            <ul className="socials">
              <li>
                <a href="#" className="icon-circle icon-circle--black">
                  <svg
                    width="8"
                    height="13"
                    viewBox="0 0 8 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.70873 12.6795V7.126H0.839844V4.96167H2.70873V3.36554C2.70873 1.51325 3.84005 0.504639 5.49242 0.504639C6.28392 0.504639 6.96418 0.563568 7.16243 0.589907V2.52566L6.01642 2.52618C5.11776 2.52618 4.94376 2.95321 4.94376 3.57984V4.96167H7.08697L6.80791 7.126H4.94376V12.6795H2.70873Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </li>

              <li>
                <a href="#" className="icon-circle icon-circle--black">
                  <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.00076 1.82294C8.80947 1.82294 9.02366 1.82971 9.73818 1.86229C10.1678 1.86755 10.5933 1.94644 10.9962 2.09552C11.2884 2.20821 11.5538 2.38084 11.7753 2.60229C11.9967 2.82375 12.1694 3.08912 12.282 3.38133C12.4311 3.78427 12.51 4.20979 12.5153 4.63939C12.5475 5.35391 12.5546 5.5681 12.5546 7.37681C12.5546 9.18552 12.5479 9.39971 12.5153 10.1142C12.51 10.5438 12.4311 10.9694 12.282 11.3723C12.1694 11.6645 11.9967 11.9299 11.7753 12.1513C11.5538 12.3728 11.2884 12.5454 10.9962 12.6581C10.5933 12.8072 10.1678 12.8861 9.73818 12.8913C9.02398 12.9236 8.80979 12.9307 7.00076 12.9307C5.19172 12.9307 4.97753 12.9239 4.26334 12.8913C3.83373 12.8861 3.40821 12.8072 3.00527 12.6581C2.71307 12.5454 2.44769 12.3728 2.22624 12.1513C2.00479 11.9299 1.83216 11.6645 1.71947 11.3723C1.57038 10.9694 1.4915 10.5438 1.48624 10.1142C1.45398 9.39971 1.44689 9.18552 1.44689 7.37681C1.44689 5.5681 1.45366 5.35391 1.48624 4.63939C1.4915 4.20979 1.57038 3.78427 1.71947 3.38133C1.83216 3.08912 2.00479 2.82375 2.22624 2.60229C2.44769 2.38084 2.71307 2.20821 3.00527 2.09552C3.40821 1.94644 3.83373 1.86755 4.26334 1.86229C4.97785 1.83004 5.19205 1.82294 7.00076 1.82294ZM7.00076 0.602295C5.16205 0.602295 4.93043 0.610037 4.20785 0.64294C3.64561 0.654123 3.08934 0.760579 2.56269 0.957779C2.11092 1.12799 1.70172 1.39473 1.36366 1.73939C1.01869 2.07758 0.751722 2.487 0.581401 2.93907C0.384201 3.46571 0.277746 4.02199 0.266563 4.58423C0.234304 5.30617 0.226562 5.53778 0.226562 7.37649C0.226562 9.2152 0.234304 9.44681 0.267208 10.1694C0.278391 10.7316 0.384847 11.2879 0.582046 11.8146C0.752178 12.2666 1.01892 12.676 1.36366 13.0142C1.70191 13.359 2.11133 13.6257 2.56334 13.7958C3.08998 13.993 3.64626 14.0995 4.2085 14.1107C4.93108 14.1429 5.16172 14.1513 7.0014 14.1513C8.84108 14.1513 9.07172 14.1436 9.7943 14.1107C10.3565 14.0995 10.9128 13.993 11.4395 13.7958C11.8893 13.6215 12.2978 13.3551 12.6389 13.0138C12.98 12.6726 13.246 12.2639 13.4201 11.8139C13.6173 11.2873 13.7238 10.731 13.735 10.1687C13.7672 9.44681 13.775 9.2152 13.775 7.37649C13.775 5.53778 13.7672 5.30617 13.7343 4.58358C13.7231 4.02134 13.6167 3.46507 13.4195 2.93842C13.2493 2.48642 12.9826 2.077 12.6379 1.73875C12.2996 1.39401 11.8902 1.12727 11.4382 0.957134C10.9115 0.759934 10.3553 0.653478 9.79301 0.642295C9.07108 0.610037 8.83947 0.602295 7.00076 0.602295Z"
                      fill="currentColor"
                    />
                    <path
                      d="M7.00215 3.89917C6.31413 3.89917 5.64155 4.10319 5.06948 4.48544C4.49741 4.86768 4.05154 5.41098 3.78824 6.04663C3.52494 6.68229 3.45605 7.38174 3.59028 8.05654C3.72451 8.73135 4.05582 9.35119 4.54233 9.8377C5.02884 10.3242 5.64868 10.6555 6.32349 10.7897C6.99829 10.924 7.69774 10.8551 8.33339 10.5918C8.96904 10.3285 9.51234 9.88262 9.89459 9.31055C10.2768 8.73848 10.4809 8.0659 10.4809 7.37788C10.4809 6.45527 10.1144 5.57045 9.46197 4.91806C8.80958 4.26568 7.92476 3.89917 7.00215 3.89917ZM7.00215 9.63594C6.55555 9.63594 6.11897 9.50351 5.74764 9.25539C5.3763 9.00727 5.08688 8.65461 4.91597 8.242C4.74506 7.8294 4.70034 7.37537 4.78747 6.93735C4.8746 6.49933 5.08966 6.09698 5.40546 5.78119C5.72125 5.46539 6.1236 5.25033 6.56162 5.1632C6.99964 5.07608 7.45367 5.12079 7.86627 5.2917C8.27888 5.46261 8.63154 5.75203 8.87966 6.12337C9.12778 6.4947 9.26021 6.93128 9.26021 7.37788C9.26021 7.97676 9.02231 8.5511 8.59884 8.97457C8.17537 9.39804 7.60102 9.63594 7.00215 9.63594Z"
                      fill="currentColor"
                    />
                    <path
                      d="M10.6176 4.5738C11.0665 4.5738 11.4305 4.20986 11.4305 3.7609C11.4305 3.31195 11.0665 2.948 10.6176 2.948C10.1686 2.948 9.80469 3.31195 9.80469 3.7609C9.80469 4.20986 10.1686 4.5738 10.6176 4.5738Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </li>
              {/* 
              <li>
                <a
                  href="https://github.com"
                  className="bg-white icon-circle icon-circle--white "
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="white"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 0C5.37 0 0 5.37 0 12C0 17.3 3.438 21.8 8.205 23.385C8.805 23.475 9.025 23.165 9.025 22.905C9.025 22.67 9.015 22.065 9.015 21.215C6 21.805 5.22 20.395 5.22 20.395C4.725 19.265 4.1 18.965 4.1 18.965C3.24 18.385 4.175 18.395 4.175 18.395C5.135 18.455 5.665 19.375 5.665 19.375C6.525 20.725 7.925 20.335 8.465 20.095C8.555 19.5 8.795 19.065 9.05 18.855C6.605 18.595 4.025 17.485 4.025 12.485C4.025 11.085 4.465 9.975 5.205 9.155C5.095 8.885 4.735 7.545 5.285 5.785C5.285 5.785 6.325 5.505 9.005 7.325C9.95 7.05 10.955 6.935 11.965 6.935C12.975 6.935 13.985 7.05 14.935 7.325C17.615 5.505 18.655 5.785 18.655 5.785C19.205 7.545 18.845 8.885 18.735 9.155C19.475 9.975 19.915 11.085 19.915 12.485C19.915 17.495 17.325 18.585 14.875 18.845C15.175 19.115 15.465 19.665 15.465 20.525C15.465 21.695 15.455 22.645 15.455 22.905C15.455 23.165 15.675 23.485 16.285 23.385C20.545 21.805 24 17.3 24 12C24 5.37 18.63 0 12 0Z"
                      fill="black"
                    />
                  </svg>
                  <BsGithub size={28} />
                </a>
              </li> */}
            </ul>
          </div>
          <ul className="flex flex-col gap-1 ">
            <li
              onClick={() => router.push("/about-us")}
              className="mt-6 cursor-pointer"
            >
              <p className="">3a Hac</p>
            </li>
            <li
              onClick={() => router.push("/personal-data")}
              className="mt-3 cursor-pointer"
            >
              <p>Лични данни</p>
            </li>
          </ul>

          {/* <div className="footer__map">
        <iframe src="https://maps.google.com/maps?q=%D0%92%D0%B0%D1%80%D0%BD%D0%B0%20%D0%A6%D0%B5%D0%BD%D1%82%D1%8A%D1%80%D0%9E%D0%B4%D0%B5%D1%81%D0%BE%D1%81,%20%D1%83%D0%BB.%20%E2%80%9E%D0%A5%D0%B0%D0%B4%D0%B6%D0%B8%20%D0%A1%D1%82%D0%B0%D0%BC%D0%B0%D1%82%20%D0%A1%D0%B8%D0%B4%D0%B5%D1%80%D0%BE%D0%B2%E2%80%9C%2032,%209000%20%D0%92%D0%B0%D1%80%D0%BD%D0%B0&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed"></iframe>
      </div> */}
        </div>

        <div className="footer__bottom pt-4 pb-12">
          <p className="copyright">
            {globals.email} &copy; 2024, Всички права запазени.
          </p>

          <ul className="footer__bottom-list">
            <li>
              <Image
                src="/temp/speedy.png"
                alt="speedy"
                width={100}
                height={100}
              />
            </li>

            <li>Наложен Платеж</li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
